import { TableLayoutModifierDialogV2 } from '../table-layout-modifier-dialog-v-2';
import { type TableLayoutModifierProps as Props } from './types';

export const TableLayoutModifier = ({ element, config }: Props) => {
  return <TableLayoutModifierDialogV2 element={element} config={config} />;
};

TableLayoutModifier.displayName = 'TableLayoutModifier';
